import { configureStore } from '@reduxjs/toolkit';
import userSettingReducer from './userSettingReducer';
import dashboardReducer from './dashboardReducer';
import myShiftsReducer from './myShiftsReducer';
import firebaseReducer from './firebaseReducer';
import systemLogReducer from './systemLogReducer';
import ddlReducer from './ddlReducer';
import searchReducer from './searchReducer';
import detailsReducer from './detailsReducer';
import BatchReducer from './BatchReducer';
import incidentsReducer from './incidentsReducer';
import incidentsPerformanceReducer from './incidentsPerformanceReducer';
import incidentsMapReducer from './incidentsMapReducer';
import importHistoryReducer from './importHistoryReducer';
import nerisSettingsReducer from './nerisSettingsReducer';
import stationAndUnitsReducer from './stationsAndUnitsReducer/slice';
import reportsDetailsReducer from './ReportsDetailsSlice/reportsDetailsReducer';
import nerisSettingsAuthoritiesReducer from './nerisSettingsAuthoritiesReducer';

const store = configureStore({
  reducer: {
    userSetting: userSettingReducer,
    dashboardReducer: dashboardReducer,
    myShiftsReducer: myShiftsReducer,
    firebaseReducer: firebaseReducer,
    systemLogReducer: systemLogReducer,
    ddlReducer: ddlReducer,
    searchReducer: searchReducer,
    detailsReducer: detailsReducer,
    BatchReducer: BatchReducer,
    incidentsReducer,
    incidentsPerformanceReducer,
    incidentsMapReducer,
    importHistoryReducer,
    nerisSettingsReducer,
    stationAndUnitsReducer,
    reportsDetailsReducer,
    nerisSettingsAuthoritiesReducer,
  },
});

export default store;
